import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { Layout } from 'views/Layout';
import { useUserRouter } from 'hooks';

import { ErrorPage } from '../ErrorPage';

export const Router = () => {
  const { getRouterChildren } = useUserRouter();

  if (!getRouterChildren) {
    return null;
  }

  return (
    <RouterProvider
      router={createBrowserRouter([
        {
          path: '/',
          element: <Layout />,
          errorElement: <ErrorPage />,
          children: getRouterChildren(),
        },
      ])}
    />
  );
};
